// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.badge[data-v-d81969ce] {\n    position: absolute;\n    top: 12px;\n    left: 10px;\n    transform: translateY(-50%) translateX(100%);\n    background-color: #f56c6c;\n    border-radius: 10px;\n    color: #fff;\n    display: inline-block;\n    font-size: 12px;\n    height: 18px;\n    line-height: 18px;\n    padding: 0 6px;\n    text-align: center;\n    white-space: nowrap;\n    border: 1px solid #fff;\n}\n", ""]);
// Exports
module.exports = exports;
